export default __webpack_public_path__ + "static/bbq-2-878c6fc60d3316c25609d5fe383c84aa.webp";